import { render, staticRenderFns } from "./EditListItem.vue?vue&type=template&id=253f0111&"
import script from "./EditListItem.vue?vue&type=script&lang=ts&"
export * from "./EditListItem.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports